// Dashboard filters
export const SET_AUDITS_DASHBOARD_FILTER = 'AUDITS/DASHBOARD/FILTERS/SET_ONE';
export const SET_AUDITS_DASHBOARD_FILTERS = 'AUDITS/DASHBOARD/FILTERS/SET_MANY';
export const REMOVE_AUDITS_DASHBOARD_FILTER = 'AUDITS/DASHBOARD/FILTERS/REMOVE_ONE';
export const CLEAR_AUDITS_DASHBOARD_FILTERS = 'AUDITS/DASHBOARD/FILTERS/CLEAR';

export const OPEN_CREATION = 'AUDITS/OPEN_CREATION';
export const CLOSE_CREATION = 'AUDITS/CLOSE_CREATION';

export const GET_NEXT_PAGE = 'AUDITS/FETCH_NEXT_PAGE';
export const GET_SIGNED_NEXT_PAGE = 'AUDITS/FETCH_SIGNED_NEXT_PAGE';
export const FETCH_AUDITS_REQUEST = 'AUDITS/FETCH_REQUEST';
export const FETCH_AUDITS_SUCCESS = 'AUDITS/FETCH_SUCCESS';
export const FETCH_AUDITS_FAILURE = 'AUDITS/FETCH_FAILURE';

export const CLEAR_AUDITS_SELECT = 'AUDITS/SELECT/CLEAR';

export const CLEAR_COLLECTION = 'AUDITS/CLEAR_COLLECTION';

// Get One
export const FETCH_AUDIT_REQUEST = 'AUDIT/FETCH_REQUEST';
export const FETCH_AUDIT_SUCCESS = 'AUDIT/FETCH_SUCCESS';
export const FETCH_AUDIT_FAILURE = 'AUDIT/FETCH_FAILURE';

// Create One
export const POST_REQUEST = 'AUDIT/POST_REQUEST';
export const POST_SUCCESS = 'AUDIT/POST_SUCCESS';
export const POST_FAILURE = 'AUDIT/POST_FAILURE';

// Update One
export const PUT_REQUEST = 'AUDIT/PUT_REQUEST';
export const PUT_SUCCESS = 'AUDIT/PUT_SUCCESS';
export const PUT_FAILURE = 'AUDIT/PUT_FAILURE';

// Clone one
export const POST_CLONE_REQUEST = 'AUDIT/POST_CLONE_REQUEST';
export const POST_CLONE_SUCCESS = 'AUDIT/POST_CLONE_SUCCESS';
export const POST_CLONE_FAILURE = 'AUDIT/POST_CLONE_FAILURE';

export const PATCH_STATUS_REQUEST = 'AUDIT/PATCH_STATUS_REQUEST';
export const PATCH_STATUS_SUCCESS = 'AUDIT/PATCH_STATUS_SUCCESS';
export const PATCH_STATUS_FAILURE = 'AUDIT/PATCH_STATUS_FAILURE';

// Start a "To start" audit (TO_START -> DRAFT): dedicated endpoint that rebuilds sections
// from the latest template version. NOT the same as PATCH /status (which requires IN_PROGRESS).
export const START_REQUEST = 'AUDIT/START_REQUEST';
export const START_SUCCESS = 'AUDIT/START_SUCCESS';
export const START_FAILURE = 'AUDIT/START_FAILURE';

// Patch assignees (assigned user / user group)
export const PATCH_ASSIGNEES_REQUEST = 'AUDIT/PATCH_ASSIGNEES_REQUEST';
export const PATCH_ASSIGNEES_SUCCESS = 'AUDIT/PATCH_ASSIGNEES_SUCCESS';
export const PATCH_ASSIGNEES_FAILURE = 'AUDIT/PATCH_ASSIGNEES_FAILURE';

// Patch start date
export const PATCH_START_DATE_REQUEST = 'AUDIT/PATCH_START_DATE_REQUEST';
export const PATCH_START_DATE_SUCCESS = 'AUDIT/PATCH_START_DATE_SUCCESS';
export const PATCH_START_DATE_FAILURE = 'AUDIT/PATCH_START_DATE_FAILURE';

export const DELETE_REQUEST = 'AUDIT/DELETE_REQUEST';
export const DELETE_SUCCESS = 'AUDIT/DELETE_SUCCESS';
export const DELETE_FAILURE = 'AUDIT/DELETE_FAILURE';

export const ENABLE_EDITION = 'AUDIT/ENABLE_EDITION';
export const DISABLE_EDITION = 'AUDIT/DISABLE_EDITION';

// Manage users in user select components
export const FETCH_USERS_SELECT_REQUEST = 'AUDIT/FETCH_USERS_SELECT_REQUEST';
export const FETCH_NEXT_USERS_SELECT_REQUEST = 'AUDIT/FETCH_NEXT_USERS_SELECT_REQUEST';
export const FETCH_USERS_SELECT_SUCCESS = 'AUDIT/FETCH_USERS_SELECT_SUCCESS';
export const CLEAR_USERS_SELECT = 'AUDIT/CLEAR_USERS_SELECT';

// Add marker (exploded view question)
export const POST_MARKER_REQUEST = 'AUDIT/POST_MARKER_REQUEST';
export const POST_MARKER_SUCCESS = 'AUDIT/POST_MARKER_SUCCESS';
export const POST_MARKER_FAILURE = 'AUDIT/POST_MARKER_FAILURE';

// Patch marker (exploded view question)
export const PATCH_MARKER_REQUEST = 'AUDIT/PATCH_MARKER_REQUEST';
export const PATCH_MARKER_SUCCESS = 'AUDIT/PATCH_MARKER_SUCCESS';
export const PATCH_MARKER_FAILURE = 'AUDIT/PATCH_MARKER_FAILURE';

// Delete marker (exploded view question)
export const DELETE_MARKER_REQUEST = 'AUDIT/DELETE_MARKER_REQUEST';
export const DELETE_MARKER_SUCCESS = 'AUDIT/DELETE_MARKER_SUCCESS';
export const DELETE_MARKER_FAILURE = 'AUDIT/DELETE_MARKER_FAILURE';

// Select marker
export const SET_SELECTED_MARKER_ID = 'AUDIT/SET_SELECTED_MARKER_ID';
export const CLEAR_SELECTED_MARKER_ID = 'AUDIT/CLEAR_SELECTED_MARKER_ID';

// Share modal open/close
export const OPEN_SHARE_MODAL = 'AUDIT/SHARE/OPEN_MODAL';
export const CLOSE_SHARE_MODAL = 'AUDIT/SHARE/CLOSE_MODAL';

// Fetch FO Url
export const FETCH_FO_URL = 'AUDIT/SHARE/FETCH_FO_URL_REQUEST';
export const FETCH_FO_URL_SUCCESS = 'AUDIT/SHARE/FETCH_FO_URL_SUCCESS';
export const FETCH_FO_URL_FAILURE = 'AUDIT/SHARE/FETCH_FO_URL_FAILURE';

// Share audit to customer
export const SHARE_AUDIT = 'AUDIT/SHARE/SHARE_AUDIT_REQUEST';
export const SHARE_AUDIT_SUCCESS = 'AUDIT/SHARE/SHARE_AUDIT_SUCCESS';
export const SHARE_AUDIT_FAILURE = 'AUDIT/SHARE/SHARE_AUDIT_FAILURE';

// Print customer view
export const PRINT_CUSTOMER_VIEW = 'AUDIT/PRINT_CUSTOMER_VIEW_REQUEST';
export const PRINT_CUSTOMER_VIEW_SUCCESS = 'AUDIT/PRINT_CUSTOMER_VIEW_SUCCESS';
export const PRINT_CUSTOMER_VIEW_FAILURE = 'AUDIT/PRINT_CUSTOMER_VIEW_FAILURE';

export const PERSISTED_ACTION_TYPES = [
  SET_AUDITS_DASHBOARD_FILTER,
  SET_AUDITS_DASHBOARD_FILTERS,
  CLEAR_AUDITS_DASHBOARD_FILTERS,
  REMOVE_AUDITS_DASHBOARD_FILTER,
];

export const FETCH_LINKED_AUDITS_REQUEST = 'AUDIT/FETCH_LINKED/REQUEST';
export const FETCH_LINKED_AUDITS_SUCCESS = 'AUDIT/FETCH_LINKED/SUCCESS';

export const DRAWER_PREVIEW_OPEN = 'AUDIT/DRAWER/PREVIEW/OPEN';
export const DRAWER_PREVIEW_CLOSE = 'AUDIT/DRAWER/PREVIEW/CLOSE';

/**
 * Successes whose payload is a single full audit (`DetailedAudit`), as opposed to a collection.
 * Every slice that mirrors a field of the audit response must react to all of them.
 */
export const SINGLE_AUDIT_SUCCESS_TYPES: string[] = [
  FETCH_AUDIT_SUCCESS,
  POST_SUCCESS,
  POST_CLONE_SUCCESS,
  PUT_SUCCESS,
  PATCH_STATUS_SUCCESS,
  START_SUCCESS,
  PATCH_ASSIGNEES_SUCCESS,
  PATCH_START_DATE_SUCCESS,
];
